import React from 'react'
import { red_info } from '../../../assets/images'
import { Tooltip } from 'antd'

const RadioGroup = ({ title = '', name = '', radioList = [], value = '', disableItem = [], tooltipText = [], disabled = false, subLabel = '',  subTitleClasses = 'ml-7', radioInputClasses = '', error = '', subTitle = [], handler, titleClasses = '', radioClasses = '', labelClases = '', classes = '', width= '400px' }) => {
  titleClasses = titleClasses || 'text-gray-700 font-semibold mb-3'
  radioClasses = 'inline-grid ' + (radioClasses || 'grid-cols-2 gap-12')
  labelClases = labelClases || 'ml-3 text-gray-600 font-semibold'

  return (
    <div className={classes}>
      {title && <h1 className={titleClasses}>{title}</h1>}
      <div className={radioClasses}>
        {radioList.map((item, index) => {
            return (
              <div key={index} className={` items-center mb-2  ${subTitle.length === 0 ? 'inline-flex': 'block'}`} style={{width: width}}>
                { (disableItem.includes(radioList[index]?.toLowerCase()) && disabled) ?
                  <Tooltip
                  placement='right'
                  title={tooltipText[index]}
                >
                  <input style={{color:'#8895af', cursor:'not-allowed'}} type='radio' disabled={disabled} id={item+name} name={name} className={radioInputClasses} onChange={handler} value={item} checked={value?.toLowerCase() === item?.toLowerCase()}/>
                  <label style={{color:'#a4b0cc'}} htmlFor={item+name} className={labelClases}>{item}{subLabel[index]}</label>
                  {subTitle && <p style={{color:'#7c8cab'}} className={subTitleClasses}>{subTitle[index]}</p>}
                </Tooltip> : 
                <>
                  <input type='radio' id={item+name} name={name} className={radioInputClasses} onChange={handler} value={item} checked={value?.toLowerCase() === item?.toLowerCase()}/>
                  <label htmlFor={item+name} className={labelClases}>{item}{subLabel[index]}</label>
                  {subTitle && <p className={subTitleClasses}>{subTitle[index]}</p>}
                </>
                }
              </div>
            )
        })}
      </div>
      {error && <span className='text-red-300 font-sm text-normal flex flex-row'><img src={red_info} style={{marginRight : '5px'}}></img>{error}</span> }
    </div>
  )
}

export default RadioGroup
